export const environment = {
  production: true,
  authServer: 'https://gw.tosca.riatlas.it/authorization',
  resourceServer: 'https://gw.tosca.riatlas.it/resource',
  fhirServer: 'https://gw.tosca.riatlas.it/fhir',
  elastic: 'https://gw.tosca.riatlas.it/resource',
  mobile: 'https://gw.tosca.riatlas.it/mobile',
  company: 'Riatlas.it',
  baseHref: 'cloud'
};
